module.exports = __webpack_public_path__ + "img/whatsapp-icon.2bccdb1c.svg";